import styled from "styled-components";
import { COLORS, fontMixins } from "../../../styles";

export const PCContainer = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	column-gap: 15px;
`;

export const PCCInfoApply = styled.div`
	position: absolute;
	${fontMixins(12, 400)};
	color: ${COLORS.Gold};
	bottom: -16px;
	right: 0;
`;

export const Label = styled.label`
	display: flex;
	${fontMixins(16, 600)};
`;

export const InputField = styled.input`
	display: flex;
	${fontMixins(16, 600)};
	border-radius: 6px 16px 16px 6px;
	border: 1px solid ${COLORS.Gold};
	padding: 4px 15px 4px 4px;
	margin: 0;
	outline: none;
	letter-spacing: 1px;
	text-align: center;
`;

export const ButtonApply = styled.button`
	position: absolute;
	display: flex;
	align-items: center;
	justify-content: center;
	right: 0;
	background: ${COLORS.Gold};
	border-radius: 50px;
	border: 0;
	width: 29.5px;
	height: 29.5px;
	color: ${COLORS.White};
	font-size: 24px;
	padding-top: 2px;
	cursor: pointer;
	transition: all 0.2s;

	&:active {
		transform: scale(0.92);
	}
`;
